import React from "react";
import FlightCheckerBase from "./FlightCheckerBase";

export default function FlightCheckerT5() {
  return (
    <FlightCheckerBase
      terminal="5"
      defaultFlight="BA458"
      title="Heathrow Terminal 5 Flight Checker | Live T5 Flight Status, Queues, Gate & Reliability"
      metaDescription="Check Heathrow Terminal 5 flights by number with live T5 flight status, arrivals/departures, gate, check-in zone, immigration or security queue times and recent reliability context."
      metaKeywords="Heathrow Terminal 5 flight checker, Heathrow T5 flight status, Heathrow Terminal 5 arrivals, Heathrow Terminal 5 departures, Heathrow T5 gate, Heathrow T5 check-in zone, T5 immigration wait time, T5 security wait, Heathrow T5 reliability"
      canonical="https://www.cheapcabgrab.com/terminal-5-flight-checker"
      ogTitle="Heathrow Terminal 5 Flight Checker | Live T5 Status, Queues & Gate"
      ogDescription="Check Heathrow Terminal 5 flights for live status, arrivals or departures, gate, check-in zone, queue times and flight reliability."
      schemaName="Heathrow Terminal 5 Flight Checker"
      breadcrumbName="Terminal 5 Flight Checker"
      headerTitle="Heathrow Terminal 5 Flight Checker"
      headerIntro="Check Heathrow Terminal 5 arrivals and departures with terminal-specific queue times, gate details and reliability context."
      headerNote="Choose the exact Heathrow Terminal 5 arrival or departure time. Today, recent past flights and the next few days are included."
      inputPlaceholder="e.g. BA458"
      emptyInputMessage="Please enter a Terminal 5 flight number (e.g. BA458)."
      notFoundMessage="Flight not found at Heathrow Terminal 5 for the selected time. Please choose another listed Terminal 5 flight."
      resultHeading="Heathrow Terminal 5 Flight Details"
      pickupLabel="Calculate Terminal 5 pickup window →"
      faqTitle="Terminal 5 FAQs"
      faqItems={[
        { question: "How busy is Heathrow Terminal 5 security today?", answer: "Terminal 5 is busiest early mornings and late afternoons; allow extra buffer at those times." },
        { question: "Is Terminal 5 slower than other terminals?", answer: "Terminal 5 is large with B and C gates; walks and transfers can add time, especially for BA long-haul banks." },
        { question: "Does Terminal 5 have eGates?", answer: "Yes, eGates are available for eligible passports at Terminal 5." },
        { question: "How long does it take to exit Terminal 5 after landing?", answer: "Typically 45–90 minutes; allow more if arriving at B or C gates or during evening peaks." },
        { question: "Where should drivers wait for Terminal 5 pickups?", answer: "Wait nearby and only enter Short Stay once the passenger confirms they are landside." },
        { question: "Does Terminal 5 have long walking distances?", answer: "Yes, especially to B and C gates; allow extra time for shuttles and walks." },
      ]}
    />
  );
}
